import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=5c053b4a&scoped=true&"
import script from "./Apps.vue?vue&type=script&lang=js&"
export * from "./Apps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c053b4a",
  null
  
)

export default component.exports